import {
  HStack, Image,
  Link,
} from "@chakra-ui/react";
import React from "react";
import { Link as GatsbyLink } from 'gatsby';
import { MenuCard } from "@components/Cards/MenuCard/MenuCard";
import { ShopIcon } from "@components/Icons/ShopIcon";
import { FundacjaIcon } from "@components/Icons/FundacjaIcon";
import { CalculatorsIcon } from "@components/Icons/CalculatorsIcon";
import mamagNews from '../../images/mamag-news.png';
import ploter from '../../images/ploter.png';
import trudnePytania from '../../images/mg-trudne-pytania.png';

export const Cards = ({isHome, background, isPopup, isMobile,onClick,...props}, ) => (
  <HStack justifyContent={isPopup?'space-between':'flex-end'}  {...props} gridArea="additionalMenu"  fontWeight="700" spacing={isHome ? '10px' : '30px'}>
    <MenuCard onClick={onClick} direction={isHome ? 'column' : 'row'} borderRadius="5px" background={background ? background : '#EAF4FF'} as={Link} href="https://rpstore.pl" icon={<ShopIcon />}>Sklep</MenuCard>
    <MenuCard onClick={onClick} direction={isHome ? 'column' : 'row'} borderRadius="5px" background={background ? background : '#EAF4FF'} as={Link} href="https://fundacjaernesta.pl" isExternal icon={<FundacjaIcon />}>Fundacja</MenuCard>
    <MenuCard onClick={onClick} direction={isHome ? 'column' : 'row'} borderRadius="5px" background={background ? background : '#EAF4FF'} as={GatsbyLink} to="/kalkulatory" icon={<CalculatorsIcon />}>Kalkulatory</MenuCard>
    {
      !isMobile && isPopup && (
        <>
          <MenuCard onClick={onClick} pt='10px' borderRadius="5px" background={background ? background : '#EAF4FF'} as={GatsbyLink} href="/trudne-pytania" icon={<Image maxH="30px" src={trudnePytania}/>}/>
          <MenuCard onClick={onClick} pt='10px' borderRadius="5px" background={background ? background : '#EAF4FF'} as={GatsbyLink} href="/ploterp" icon={<Image maxH="30px" src={ploter}/>}/>
          <MenuCard onClick={onClick} pt='10px' borderRadius="5px" background={background ? background : '#EAF4FF'} as={GatsbyLink} href="/mgnews" icon={<Image maxH="30px" src={mamagNews}/>}/>
        </>
      )
    }
  </HStack>
)
